const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '备案信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            const guid = this.form.businessKey.split(':')[1]
            // 陈TODO 检查为什么获取不到记录详情
            this.$request.post(`/transformToAfter/gt-jy-jianguan/api/zbBeiAn/getDetail.do`, {
                guid: guid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '招标项目名称': res.data.projectName,
                    '备案单号': res.data.beianDanhao,
                    '项目法人名称': res.data.farenName,
                    '项目法人负责人': res.data.farenFuzeren,
                    '招标负责人及联系人': res.data.zbFuzeren,
                    '招标负责人联系电话': res.data.zbFuzerenDianhua,
                    '实施地点': res.data.shishiDidian,
                    '批准核算或年度计划': res.data.hesuanOrJihua,
                    '项目批准机关': res.data.pizhunJiguan,
                    '项目批准文号': res.data.pizhuanJihuanwenhao,
                    '项目批准时间': this.$util.timeFormatter(res.data.pizhunTime),
                    '招标组织形式核准机关': res.data.zuzhiXingshiJiguan,
                    '招标组织形式核准文号': res.data.zuzhiXingshiWenhao,
                    '招标组织形式核准时间': this.$util.timeFormatter(res.data.zuzhiXingshiTime),
                    '招标方式核准机关': res.data.fangshiJiguan,
                    '招标方式核准文号': res.data.fangshiWenhao,
                    '招标方式核准时间': this.$util.timeFormatter(res.data.fangshiTime),
                    '招标代理机构名称': res.data.zbDailiName,
                    '招标代理机构负责人': res.data.zbDailiFuzeren,
                    '招标代理机构资格等级': res.data.zbDailiZizhi,
                    '招标代理机构资格证书编号': res.data.zbDailiZhenshubianhao,
                    '招标代理机构资格发证机关': res.data.zbDailiFazhengjiguan,
                    '招标内容': res.data.zbContent,
                }
            })
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
